/*
 *  (c) 2015 - 2023 ENISCO by FORCAM GmbH
 */

import {Box, IconButton, Typography} from '@mui/material'
import React, {useState} from 'react'
import {Person} from '@mui/icons-material'
import {UserOptions} from './menus/UserOptions'
import {useUserName} from '@enisco/mcc-react-lib'
import useMediaQuery from '@mui/material/useMediaQuery'
import {Theme} from '@mui/material/styles'

const UserBox: React.FC = () => {
  const [userMenuAnchor, setUserMenuAnchor] = useState<Element>()
  const userName = useUserName()
  const hidden = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'))

  const showPopup = (event: any) => {
    setUserMenuAnchor(event.currentTarget)
  }

  return (
    <Box flexDirection='row' display='flex' alignItems='center'>
      <IconButton onClick={showPopup} size='large'>
        <Person />
      </IconButton>
      {hidden ? null : (
        <Typography
          variant='body1'
          onClick={(event: any) => {
            setUserMenuAnchor(event.currentTarget)
          }}
        >
          {userName}
        </Typography>
      )}
      <UserOptions anchorEl={userMenuAnchor} setAnchorEl={setUserMenuAnchor} />
    </Box>
  )
}

export default UserBox
